import {useNavigation} from '@react-navigation/native';
import React, {useState} from 'react';
import {Linking, View, StyleSheet} from 'react-native';
import {Checkbox, FullButton} from '../../components/common';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';
import config from '../../config';

export const DeleteAccount = () => {
  const {goBack} = useNavigation();
  const [isChecked, setIsChecked] = useState(false);

  const styles = getStyles();

  const toggleIsChecked = () => setIsChecked(!isChecked);

  const onConfirm = () => {
    Linking.openURL(config.GENESYS_DELETE_ACCOUNT_URL);
    goBack();
  };

  return (
    <View style={styles.container}>
      <View style={styles.checkboxesContainer}>
        <Checkbox
          style={styles.checkbox}
          labelStyle={styles.termsText}
          onPress={toggleIsChecked}
          isChecked={isChecked}
          text={I18n.t('Dashboard.DeleteAccount.content')}
          lightColors
        />
      </View>
      <View style={styles.bottomContainer}>
        <FullButton
          disabled={!isChecked}
          text={I18n.t('Dashboard.DeleteAccount.confirm')}
          onPress={onConfirm}
        />
      </View>
    </View>
  );
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'space-between',
    },
    safeareaview: {
      flex: 1,
      backgroundColor: theme.dashboardBackgroundColor,
    },
    checkboxesContainer: {
      marginVertical: 17,
      marginHorizontal: 17,
    },
    checkbox: {
      marginBottom: 10,
    },
    bottomContainer: {
      marginVertical: 17,
      marginHorizontal: 20,
    },
    fullbutton: {
      marginHorizontal: 17,
    },
    termsText: {
      fontSize: 16,
      lineHeight: 15,
      textAlign: 'left',
    },
  });
